const ArrowPosition = {
  'top-left': 'top-left',
  'top-center': 'top-center',
  'top-right': 'top-right',
  'right-top': 'right-top',
  'right-center': 'right-center',
  'right-bottom': 'right-bottom',
  'bottom-right': 'bottom-right',
  'bottom-center': 'bottom-center',
  'bottom-left': 'bottom-left',
  'left-bottom': 'left-bottom',
  'left-center': 'left-center',
  'left-top': 'left-top'
};

export { ArrowPosition };
//# sourceMappingURL=arrowPosition.js.map
